import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import Modal from "react-responsive-modal";
import autoBind from "react-autobind";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import { Player } from "video-react";

import "../../../node_modules/video-react/dist/video-react.css";
import { getUrlForValue } from "../../actions/drive";
import { getSelectedActivityId, hideVideoPreview } from "../../actions/playerActions";

import SyntheticVoiceApi from "../../speech/SyntheticVoiceApi";
class VideoPreview extends PureComponent {
	constructor(props) {
		super(props);
		autoBind(this);
		this.videoPlayerRef = React.createRef();
		this.state = { paused: false };
	}

	onClickShare() {

	}

	onClickClose() {
		this.setState({ paused: true });
		if (this.props.onClickClose) {
			this.props.onClickClose();
		}
	}

	onModalEntered() {
		this.videoPlayerRef.current.play();
	}

	//TODO: need delay to start video when transition ends
	render() {
		let modal = null;

		if (this.props.videoUri !== null && this.props.videoUri !== "undefined" && this.props.videoUri !== "") {
			const url = getUrlForValue(this.props.videoUri, getSelectedActivityId());
			modal =
				<Modal classNames={{
					overlay: "ambifi-web-player",
					modal: "media-preview-modal",
					transitionEnter: "ambifi-web-player-modal-slide-up-enter",
					transitionEnterActive: "ambifi-web-player-modal-slide-up-enter-active",
					transitionExit: "ambifi-web-player-modal-slide-up-exit",
					transitionExitActive: "ambifi-web-player-modal-slide-up-exit-active"
				}}
					open={this.props.isOpen}
					showCloseIcon={false}
					onEntered={this.onModalEntered}
					onClose={() => { }}>
					<div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%" }}>
						<div style={{ flex: 1, padding: "10px" }}>
							<Player key="videoPlayer" src={url}
								playbackRate={1}
								paused={this.state.paused}
								volume={1}
								muted={false}
								onError={e => console.log(e)}
								onLoadStart={() => SyntheticVoiceApi.stop()}
								onEnded={() =>  hideVideoPreview() }
								autoPlay={false}
								playsInline

								fluid={false}
								width={"100%"}
								height={"100%"}
								ref={this.videoPlayerRef}
							/>
						</div>
						<div style={{ display: "flex", flexDirection: "row", padding: "12px", justifyContent: "flex-start" }}>
						{/*
							<div style={{ cursor: "pointer" }} onClick={this.onClickShare}>
								<FontAwesomeIcon style={{ color: "lightgreen", opacity: 1, fontSize: "32px" }} icon="share-alt" />
							</div>
						*/} 
							<div style={{ cursor: "pointer" }} onClick={this.onClickClose}>
								<FontAwesomeIcon style={{ color: "red", opacity: 1, fontSize: "32px" }} icon='times' />
							</div>
						</div>
					</div>
				</Modal>;
		}

		return modal;
	}
}

VideoPreview.defaultProps = {
	paused: true,
	repeat: false,
	volume: 1,
	muted: true
};

export default branch({
}, VideoPreview);